/**
 * @generated SignedSource<<9cc9618dd4feacd3b4de7ec0470c917d>>
 * @relayHash 945ac47061c6b64e32334809f19e8801
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e2d4e3f42ad032b92771d1c2a11a69e144dcf3f4fc43bab0bc30af20300bcbe6

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type content_servicedeskSettingsVirtualAgentCreateIntents_PaginatedIntentTemplatesQuery$variables = {
  count?: number | null | undefined;
  cursor?: string | null | undefined;
  id: string;
  isDiscoveredTemplatesTimestampEnabled: boolean;
  isGateIntentTemplatesBehindAiToggleEnabled: boolean;
};
export type content_servicedeskSettingsVirtualAgentCreateIntents_PaginatedIntentTemplatesQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplatesDataRef">;
  } | null | undefined;
};
export type content_servicedeskSettingsVirtualAgentCreateIntents_PaginatedIntentTemplatesQuery = {
  response: content_servicedeskSettingsVirtualAgentCreateIntents_PaginatedIntentTemplatesQuery$data;
  variables: content_servicedeskSettingsVirtualAgentCreateIntents_PaginatedIntentTemplatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 20,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDiscoveredTemplatesTimestampEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isGateIntentTemplatesBehindAiToggleEnabled"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "content_servicedeskSettingsVirtualAgentCreateIntents_PaginatedIntentTemplatesQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              {
                "kind": "Variable",
                "name": "isDiscoveredTemplatesTimestampEnabled",
                "variableName": "isDiscoveredTemplatesTimestampEnabled"
              }
            ],
            "kind": "FragmentSpread",
            "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplatesDataRef"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "content_servicedeskSettingsVirtualAgentCreateIntents_PaginatedIntentTemplatesQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v8/*: any*/),
                "concreteType": "VirtualAgentIntentTemplatesConnection",
                "kind": "LinkedField",
                "name": "intentTemplates",
                "plural": false,
                "selections": [
                  {
                    "condition": "isGateIntentTemplatesBehindAiToggleEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasDiscoveredTemplates"
                      }
                    ]
                  },
                  {
                    "condition": "isDiscoveredTemplatesTimestampEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "lastDiscoveredTemplatesGenerationTime"
                      }
                    ]
                  },
                  {
                    "concreteType": "VirtualAgentIntentTemplateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "VirtualAgentIntentTemplate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "noOfQuestions"
                          },
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v8/*: any*/),
                "handle": "connection",
                "key": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplates",
                "kind": "LinkedHandle",
                "name": "intentTemplates"
              }
            ],
            "type": "JiraProject"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e2d4e3f42ad032b92771d1c2a11a69e144dcf3f4fc43bab0bc30af20300bcbe6",
    "metadata": {},
    "name": "content_servicedeskSettingsVirtualAgentCreateIntents_PaginatedIntentTemplatesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "915031d521ef1e657922ee1b44339a0d";

export default node;
